import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/index'
import mitt from 'mitt'

import HighchartsVue from 'highcharts-vue'

import { popover } from './plugins/popover.js'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far)
dom.watch()

const emitter = mitt()

const app = createApp(App).component('font-awesome-icon', FontAwesomeIcon)
app.use(HighchartsVue)
app.use(createPinia())
app.use(router)
app.config.globalProperties.emitter = emitter

app.directive('popover', popover)
app.mount('#app')
